<template>
  <router-view></router-view>
</template>

<script setup>
import { onMounted } from 'vue'
import { setupBeforeInstallPrompt, IS_INSTALL_PROMPT_SUPPORTED } from './utils/installPrompt'
import { shareSuccess } from './utils'

onMounted(() => {
  shareSuccess()
  console.log('suport add desk-----1')
  if (IS_INSTALL_PROMPT_SUPPORTED) {
    console.log('suport add desk-----2')
    setupBeforeInstallPrompt()
  } else {
    console.log('unsuport add desk-----3')
  }
})
</script>
